import React, { useState } from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { useListingData } from "~/context/ListingPageDataContext";
import { AppModalKey, useAppModal } from "~/modals";
import { IAddOnItem } from "~/types/api-types";

import { AddOnItem } from "./add-on-item";

interface AddOnsProps {
  addonItems: IAddOnItem[];
  totalResults?: number;
  addOnsCategories?: Record<string, unknown>;
}

const AddOns: React.FC<AddOnsProps> = ({ addonItems = [] }) => {
  const {
    data: { listingId },
  } = useListingData();
  const [hideExtraItems, setHideExtraItems] = useState(true);
  const { openModal: openAddOnModal } = useAppModal(
    AppModalKey.ListingAddOnModal,
  );
  const totalItems = addonItems.length;

  const toggleModal = (item: IAddOnItem) => {
    window.analyticsIntegrations.trackEvent("listing addon viewed", {
      listing_id: listingId,
      addon_id: item._id,
      img_id: item.backgroundImg || "",
    });

    openAddOnModal({ addOnItem: item });
  };

  const toggleShowMoreItems = () => {
    setHideExtraItems(!hideExtraItems);
  };
  return (
    <>
      <hr className="tw-w-full tw-text-gray-200 tw-border-[1px]" />
      <div className="AddonsSection tw-py-40" id="addons_section">
        <div className="tw-mb-24">
          <Text element="h2" typeface="headline-2-m" className="tw-mb-12">
            <FormattedMessage
              id="listing.add_ons_section.title"
              defaultMessage="Add-ons from the host"
            />
          </Text>
          <Text element="p" typeface="body-2" className="tw-text-gray-600">
            <FormattedMessage
              id="listing.add_ons_section.text"
              defaultMessage="Host provided services, items or options. Available at checkout."
            />
          </Text>
        </div>

        <div className="add-ons-wrap tw-grid md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-16 tw-gap-y-16 tw-mb-24">
          {(addonItems || [])
            .filter((_, i) => !hideExtraItems || i < 6)
            .map((item, i) => (
              <button onClick={() => toggleModal(item)} key={`addon-item-${i}`}>
                <div className="tw-py-8 hover:tw-bg-gray-100 tw-block">
                  <AddOnItem item={item} listingPageDisplay={true} />
                </div>
              </button>
            ))}
        </div>
        {6 < totalItems && (
          <Button variant="underline" onClick={toggleShowMoreItems}>
            {hideExtraItems ? (
              <FormattedMessage
                id="listing.add_ons_section.show_all"
                defaultMessage="Show All"
              />
            ) : (
              <FormattedMessage
                id="listing.add_ons_section.show_less"
                defaultMessage="Show Less"
              />
            )}
          </Button>
        )}
      </div>
    </>
  );
};

export default AddOns;
